//#region : Imports

import { Injectable, SecurityContext } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Router } from "@angular/router";

import Swal from "sweetalert2";

import { ScanHolder, DeviceScans } from "./components/stats/stats.model";

const md5 = require("md5");

import * as moment from "moment";

import { EventEmitter } from "events";

import { buildSettings, AccessLevel, AccessGroup } from "./settings";

import { DomSanitizer } from "@angular/platform-browser";
declare var $: any;

//#endregion

@Injectable({
  providedIn: "root",
})
export class GlobalsService {
  //Constants
  public readonly appName: string = buildSettings.appName;
  public readonly thisSite: string = "appsafest.com";
  public readonly in4merSite: string = "in-4mer.com";
  public readonly company: string = "Stone Holdings";
  public readonly contact: string = "leslie@stoneholdings.co.za";

  //IN4MER API
  public readonly apiKey: string = buildSettings.apiKey;
  public readonly apiRootNew: string = buildSettings.apiRoot;

  // public readonly apiRootNew: string = `http://localhost:3005/api/usr`;

  //Maps
  public readonly mapKey: string = "AIzaSyD6IdEf_pshoZlYzqvDkWUy4PZ9blRiVe0";

  //Vars
  public currentLicence: any = null;
  public currentView: "login" | "dashboard" = "login";
  public currentPeriod: string = "";
  public printTitle: string = "";
  private timerSession: any = null;
  public dateTimeFormat: string = "YYYY-MM-DD HH:mm:ss";
  public dateFormat: string = "YYYY-MM-DD";
  public timeFormat: string = "HH:mm:ss";
  public loading: boolean = false;
  public currentPage: "analytics" | "map" = "analytics";
  public syncStatus: string = "Syncing";
  public syncTime: string = moment().format(this.dateTimeFormat);
  public globalEvents: EventEmitter = new EventEmitter();
  public signingOut: boolean = false;

  //Default headers -> set in constructor
  private httpHeaders: any;

  //Session parameters
  public token: string = null;
  public personid: string = null;
  public username: string = null;
  public nickname: string = null;
  public userAccess: any = null;
  public acclist: any = [];
  public tester: string = null;
  public address: string = null;
  public avatarBase64: string = null;
  public email: string = null;
  public about: string = null;
  public entityAccid: string = null;
  public entityLogoBase64: string = null;
  public entityName: string = null;
  public entityDescription: string = null;
  public entityEmail: string = null;
  public entityPhone: string = null;
  public entityWeb: string = null;
  public entityAddress: string = null;
  public customUrl: string = "";
  public orgUnits: any = [];
  public iotActive: boolean = false;
  public iotAccess: boolean = false;
  public iotToken: string = null;
  public classes: any = [];
  public container: string = "";
  public agentDefaultState = "";
  // public rule1ScriptId = "5eb900aeb3d1e4650ca557aa";
  // public rule2ScriptId = "5e9dc6d90e0da375c3af6c6a";
  public loggedOut = false;

  //Roles must be from high to low access
  public roles: any = [];
  public defRoles: string[] = [
    "root",
    "super",
    "agent",
    "owner",
    "manager",
    "user",
  ];
  public allowedRoles: string[] = [];

  //Analytics
  //Map<dayId, Map<snr, ScanDay>>
  public dataMap: Map<string, Map<string, ScanHolder>> = new Map();
  public deviceScans: DeviceScans[] = [];
  public activeDevices: number = 0;

  //Build configuration
  public buildSettings = buildSettings;

  private swalWithBootstrapButtons: any = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-simple mr-2",
    },
    buttonsStyling: false,
  });

  constructor(
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("api-key", this.apiKey);

    $(window).resize(() => {
      this.globalEvents.emit("resize");
    });
  }

  public clearSessionData() {
    this.token = null;
    this.personid = null;
    this.username = null;
    this.nickname = null;
    this.userAccess = null;
    this.acclist = [];
    this.tester = null;
    this.address = null;
    this.avatarBase64 = null;
    this.email = null;
    this.about = null;
    this.entityAccid = null;
    this.entityLogoBase64 = null;
    this.entityName = null;
    this.entityDescription = null;
    this.entityEmail = null;
    this.entityPhone = null;
    this.entityWeb = null;
    this.entityAddress = null;
    this.customUrl = "";
    this.orgUnits = [];
    this.iotActive = false;
    this.iotAccess = false;
    this.iotToken = null;
    this.classes = [];
    this.container = "";
  }

  public isMobile(): boolean {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  //#region : API calls

  public login(
    username: string,
    password: string,
    token: string = null,
    otp?: string,
    tfa: "enabled" | "skip" | "no-ask" = "no-ask",
    onSuccess?: () => void,
    onFailure?: (res?: any) => void,
    onTFA?: (result: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRootNew + "/account/login";
    let pwd = md5(password);

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      username: username,
      password: pwd,
      otp: otp,
      name: this.appName,
      tfa: tfa,
    };

    //Add the token?
    if (token) body.token = token;

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          //Two factor authentication
          if (r.tfa) {
            let tfa: "scan" | "otp" | "good" = r.tfa;

            if (tfa == "scan" || tfa == "otp") {
              if (onTFA) onTFA(r);

              return;
            }
          }

          //Keep the user information
          this.nickname = r.name;
          this.userAccess = r.access;
          this.token = r.token;
          this.personid = r.personid;
          this.username = username;
          this.email = r.email;
          this.about = r.about;
          this.tester = r.tester;
          this.avatarBase64 = r.avatar;
          this.address = r.address;
          this.acclist = r.acclist ? r.acclist : [];
          this.iotActive = r.iotActive;
          this.iotAccess = r.iotAccess;
          this.orgUnits = r.orgUnits;
          this.agentDefaultState = r.agent_default_state;

          //Show Primary?
          let showPrimary = true;
          let hideUnlinkedSecondary = false;

          //Manage user type access TODO: set in buildSettings
          if (this.buildSettings && this.buildSettings.manageAppUserAccess) {
            if (this.userAccess.role == "user" && !r.dash_access) {
              showPrimary = false;
            }
            if (this.userAccess.role == "user") {
              hideUnlinkedSecondary = true;
            }
          }
          // filter acclist
          // this.acclist = this.filterAccList(this.acclist, (accs: any) =>
          this.acclist = this.filterAccList(
            this.acclist,
            (accs: any) => {
              this.acclist = accs;
              this.resetRoles();
              this.roles = this.roles.slice(
                this.roles.indexOf(this.userAccess.role)
              );

              //Reset the IoT token
              this.iotToken = null;

              //Trigger handlers and callback

              if (this.acclist.length > 0 || showPrimary) {
                this.handleSuccess(response);
                this.resetSession();
                if (onSuccess) onSuccess();
              } else {
                let rply = {
                  message: "No active accounts",
                };
                if (onFailure) onFailure(rply);
              }
            },
            showPrimary,
            hideUnlinkedSecondary
          );

          //Setup the roles
          //You can only assign roles with access levels lower than yourself
          //Provided that you have EXECUTE rights
          // this.resetRoles();
          // this.roles = this.roles.slice(this.roles.indexOf(this.userAccess.role));

          // //Reset the IoT token
          // this.iotToken = null;

          // //Trigger handlers and callback
          // this.handleSuccess(response);
          // this.resetSession();
          // if (onSuccess) onSuccess();
        } else {
          // if (r.message == "User not active" || r.error == 108)
          // {
          //     this.showWarningAlert("Error", "Account suspended.")
          // }
          // else
          // {

          // this.handleBadStatus(response);
          if (onFailure) onFailure(r);
          // }
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public filterAccList(
    acclist: any,
    onSuccess: (res: any) => void,
    show_primary: boolean = true,
    hideUnlinkedSecondary: boolean = false
  ) {
    let hide = hideUnlinkedSecondary;
    //Get Primary AccInfo
    this.accountInfo((res: any) => {
      let retVal = [];
      console.log(res);

      //Push Primary
      let primary = {
        accid: res.accid,
        creator: this.buildSettings.creator,
        name: res.name,
        description: res.description,
        primary: true,
      };
      if (show_primary) {
        retVal.push(primary);
      }
      for (let i = 0; i < acclist.length; i++) {
        let acc = acclist[i];

        let cr = this.buildSettings.creator;
        console.log(hideUnlinkedSecondary);

        if (acc && acc.creator && acc.creator == cr) {
          if (!hideUnlinkedSecondary) {
            //Do not hide unlinked for users other than of type 'user'
            retVal.push(acc);
          } else if (hideUnlinkedSecondary && acc.dash_access_linked) {
            //Show if dash_access_linked = true
            retVal.push(acc);
          }
        }
      }
      onSuccess(retVal);
    });

    // return retVal;
  }

  public resetpass(
    username: string,
    onSuccess?: (res: any) => void,
    onFailure?: () => void
  ) {
    //REST endpoint
    let endpoint = this.apiRootNew + "/account/resetpass";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      username: username,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          //Trigger handlers and callback
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleUpdatePassword(
    password: string,
    onSuccess?: (response?: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/updatepass/";
    let pwd = md5(password);
    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      hashpassword: pwd,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleLinkAgent(
    personid: string,
    state: boolean,
    remove?: boolean,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/agent/link/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      state: state,
      remove: remove,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleLinkAgentAnon(
    personid: string,
    access?: boolean,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/agent/anonymous/link/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      accid: this.entityAccid,
      personid: personid,
      access: access,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleLinkByEmail(
    email: string,
    role: string,
    onSuccess?: (person?: any) => void,
    onFailure?: () => void,
    access: boolean = false
  ) {
    let endpoint = this.apiRootNew + "/people/agent/email/link/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      email: email,
      accid: this.entityAccid,
      role: role,
      access: access,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountAdd(
    name: string,
    description: string,
    phone: string,
    address: string,
    email: string,
    logo: string,
    web: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/add/";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      name: name,
      email: email,
      description: description,
      phone: phone,
      address: address,
      logo: logo,
      web: web,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountConfigureNew(
    companyName: string,
    name: string,
    description: string,
    phone: string,
    address: string,
    email: string,
    logo: string,
    web: string,
    licenceMaxDevices: number,
    licenceValidDate: string,
    classname: string,
    devices: any,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/configure/new/";

    //email to lowercase
    email = email.toLowerCase();

    let options = {
      headers: this.httpHeaders,
    };

    let rules = [
      {
        name: "Session Count",
        message: "Checkpoint Session",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 10,
        script: "5eb900aeb3d1e4650ca557aa",
      },
      {
        name: "Elevated Temperature",
        message: "Elevated temperature detected",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 0,
        script: "5e9dc6d90e0da375c3af6c6a",
      },
    ];

    let body: any = {
      token: this.token,
      guid: this.personid,
      name: name,
      companyName: companyName,
      email: email,
      phone: phone,
      description: description,
      address: address,
      logo: logo,
      web: web,
      licenceMaxDevices: licenceMaxDevices,
      licenceValidDate: licenceValidDate,
      classname: "Devices",
      rules: rules,
      devices: devices,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountRegisterNew(
    companyName: string,
    name: string,
    phone: string,
    email: string,
    password: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/register/";

    //email to lowercase
    email = email.toLowerCase();

    let options = {
      headers: this.httpHeaders,
    };
    let pwdHash = md5(password);

    let body: any = {
      name: name,
      companyName: companyName,
      email: email,
      phone: phone,
      password: pwdHash,
      addMobile: true,
      bucket: this.buildSettings.bucketDetails,
      linkedUsers: this.buildSettings.linkedUsers,
      active: this.buildSettings.activateAccount,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountNotify(
    recipients: any,
    subject: string,
    header: string,
    info: string,
    data: any,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/notify/";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      recipients: recipients,
      subject: subject,
      header: header,
      info: info,
      data: data,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        // this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountNewUserNotify(
    recipients: any,
    subject: string,
    username: string,
    password: string,
    name: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/notify/new/user";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      recipients: recipients,
      subject: subject,
      username: username,
      password: password,
      name: name,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        // this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountNewAccountNotify(
    recipients: any,
    subject: string,
    username: string,
    password: string,
    name: string,
    licKey?: string,
    licDate?: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/notify/new/account";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      recipients: recipients,
      subject: subject,
      username: username,
      password: password,
      name: name,
      licenceKey: undefined,
      licenceValidDate: undefined,
    };

    if (licKey) body.licenceKey = licKey;
    if (licDate) body.licenceValidDate = licDate;

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        // this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountToggleActive(
    accid: string,
    flag: boolean,
    onSuccess?: (r: any) => void,
    onFailure?: () => void,
    notify: boolean = false
  ) {
    let endpoint = this.apiRootNew + "/account/toggle/active/";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      accid: accid,
      flag: flag,
      notify: notify,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountUpdateName(
    name: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/edit/";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      name: name,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountSetDefaultAgentState(
    state: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/set/agent/default/state";

    let options = {
      headers: this.httpHeaders,
    };

    let body: any = {
      token: this.token,
      state: state,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleGetByToken(
    onSuccess?: (response?: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/getByToken/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleAdd(
    name: string,
    email: string,
    roleName: string,
    username: string,
    password: string,
    phone?: string,
    onSuccess?: (res: any) => void,
    onFailure?: (response?: any) => void
  ) {
    let endpoint = this.apiRootNew + "/people/add/";

    let options = {
      headers: this.httpHeaders,
    };

    let pwd = md5(password);
    //lowercase email
    email = email.toLowerCase();

    let body: any = {
      token: this.token,
      name: name,
      email: email,
      role: roleName,
      username: username,
      password: pwd,
      ask: false,
      addMember: true,
      phone: phone,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure(response);
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleDelete(
    personid: string,
    username: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/delete/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      username: username,
      deleteMember: true,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public memberDelete(
    personid: string,
    username: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/delete/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      username: username,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleEdit(
    personid: string,
    name: string,
    email: string,
    address: string,
    about: string,
    avatar: string,
    roleName: string,
    tester: string,
    onSuccess?: () => void,
    onFailure?: () => void,
    dash_access: boolean = true
  ) {
    let endpoint = this.apiRootNew + "/people/edit/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      name: name,
      email: email,
      address: address,
      about: about,
      avatar: avatar,
      role: roleName,
      tester: tester,
      dash_access: dash_access,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleExists(
    email: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/exists/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      email: email,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleEndSession(
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/end/session";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        // this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleExistsByUsername(
    username: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/exists/username";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      username: username,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountExists(
    email: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/exists/";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      email: email,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public peopleAddByAccid(
    accid: string,
    name: string,
    email: string,
    roleName: string,
    username: string,
    password: string,
    onSuccess?: (res: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/people/addToAccount/";

    let options = {
      headers: this.httpHeaders,
    };
    let pwd = md5(password);
    let body: any = {
      token: this.token,
      accid: accid,
      name: name,
      email: email,
      role: roleName,
      username: username,
      password: pwd,
    };

    //Do the post
    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public containerLogin(
    onSuccess?: (r: any) => void,
    onFailure?: () => void,
    suppressErrors: boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/container/login",
      body: {},
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          //Get the token
          this.iotToken = r.data.token;
          this.classes = r.data.classes;
          this.container = r.data.id;

          // this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          if (suppressErrors === false) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (suppressErrors === false) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public devRootSearch(
    snr: string,
    onSuccess?: (r: any) => void,
    onFailure?: () => void,
    suppressErrors: boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/device/search";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      snr: snr,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          // this.handleSuccess(response);
          if (onSuccess) onSuccess(response);
        } else {
          if (suppressErrors === false) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (suppressErrors === false) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public incidentList(
    from: Date,
    to: Date,
    incidentId?: string,
    classId?: string,
    onSuccess?: (incidents: any) => void,
    onFailure?: () => void,
    suppressErrors: Boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/incident/list",
      body: {
        token: this.iotToken,
        from: from.toISOString(),
        to: to.toISOString(),
        incidentId: undefined,
        classId: undefined,
      },
    };
    if (incidentId && incidentId !== null) body.body.incidentId = incidentId;
    if (classId && classId !== null) body.body.classId = classId;

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          // this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (!suppressErrors) {
            if (!this.loggedOut) {
              this.handleBadStatus(response);
              if (onFailure) onFailure();
            }
          }
        }
      },
      (error) => {
        if (!suppressErrors) {
          if (!this.loggedOut) {
            this.handleApiErrors(error);
            if (onFailure) onFailure();
          }
        }
      }
    );
  }

  public deviceAdd(
    devName: string,
    devSnr: string,
    model: string,
    classes?: any,
    specifics?: any,
    onSuccess?: (result: any) => void,
    onFailure?: (res?: any) => void,
    host: string = undefined
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let prefix = this.buildSettings.device_prefix;

    let flavour = this.buildSettings.appName;

    let deviceObj = {
      token: this.iotToken,
      model: model,
      snr: `${prefix}${devSnr}`,
      host: undefined,
      name: devName,
      enabled: true,
      deployed: false,
      classes: undefined,
      specifics: undefined,
      flavour: flavour,
    };

    if (host) deviceObj.host = host;

    if (classes && classes.length > 0) deviceObj.classes = classes;
    if (specifics && specifics.length > 0) deviceObj.specifics = specifics;
    //Mark Pool/Romulus/Temp devices as deployed
    if (
      model == "rom.pte" ||
      model == "rom.ptw" ||
      model == "tag.tmp" ||
      model == "tag.tmo" ||
      model == "tag.dry" ||
      model == "lora.nanotag" 
    ) {
      deviceObj.deployed = true;
    }

    let body = {
      token: this.token,
      endpoint: "/device/add",
      body: deviceObj,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (r.proxy && r.proxy.failure && r.proxy.failure.errmsg) {
            let errmsg = r.proxy.failure.errmsg;

            if (errmsg.includes("E11000 duplicate key error index")) {
              r.message = "E11000 duplicate serial number.";
            }
          }

          this.handleBadStatus(r);
          if (onFailure) onFailure(response);
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public deviceTransfer(
    currentSnr,
    newSnr,
    newAccountNr,
    currentAccountNr,
    onSuccess?: (result: any) => void,
    onFailure?: (res?: any) => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let transferObj = {
      token: this.iotToken,
      currentSnr: currentSnr,
      newSnr: newSnr,
      newAccountNr: newAccountNr,
      currentAccountNr: currentAccountNr,
      validate: false,
    };

    let body = {
      token: this.token,
      endpoint: "/device/transfer",
      body: transferObj,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(r);
          if (onFailure) onFailure(response);
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  getModels() {
    let modelsList = [];
    let models = this.buildSettings.models ? this.buildSettings.models : [];

    for (let i = 0; i < models.length; i++) {
      let model = models[i];

      modelsList.push(model.code);
    }

    // if (modelsList.length === 0) modelsList = undefined;

    return modelsList;
  }

  public deviceList(
    classId?: string,
    models?: [],
    snrs?: [],
    classes?: [],
    onSuccess?: (devices: any) => void,
    onFailure?: () => void,
    suppressErrors: Boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/device/list",
      body: {
        token: this.iotToken,
        classId: undefined,
        models: undefined,
        snrs: undefined,
        classes: undefined,
      },
    };

    if (classId && classId !== null) body.body.classId = classId;
    if (models && models !== null) body.body.models = models;
    if (snrs && snrs !== null) body.body.snrs = snrs;
    if (classes && classes !== null) body.body.classes = classes;

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (!suppressErrors) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (!suppressErrors) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public deviceVerify(
    snrs: any,
    onSuccess?: (devices: any) => void,
    onFailure?: (mess?: string) => void,
    suppressErrors: Boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/device/validate",
      body: {
        token: this.iotToken,
        devices: snrs,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (!suppressErrors) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (!suppressErrors) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public deviceSet(
    deviceId: string,
    deviceObj: any,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    //Add the token
    deviceObj.token = this.iotToken;

    let body = {
      token: this.token,
      endpoint: "/device/set",
      body: {
        token: this.iotToken,
        deviceId: deviceId,
        data: deviceObj,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public rawDeleteAll(
    snr: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/raw/delete/all",
      body: {
        token: this.iotToken,
        snr: snr,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public classSet(
    classId: string,
    classObj: any,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    //remove unwanted entries
    if (classObj._id) delete classObj._id;
    if (classObj.container) delete classObj.container;
    if (classObj.created) delete classObj.created;

    let body = {
      token: this.token,
      endpoint: "/class/set",
      body: {
        token: this.iotToken,
        classId: classId,
        data: classObj,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public deviceRemove(
    deviceId: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/device/remove",
      body: {
        token: this.iotToken,
        deviceId: deviceId,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public licenceAdd(
    maxDevs: number,
    expiryDate: string,
    type: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/licence/create",
      body: {
        token: this.iotToken,
        maxDevices: maxDevs,
        expiryDate: expiryDate,
        type: type,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public vaultRemoveBySnr(
    snr: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/vault/removeBySnr",
      body: {
        token: this.iotToken,
        snr: snr,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          // this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public rawList(
    snr: string,
    from: Date,
    to: Date,
    beginnings?: string,
    onSuccess?: (raws: any) => void,
    onFailure?: () => void,
    suppressErrors: Boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/raw/list",
      body: {
        token: this.iotToken,
        snr: snr,
        from: from.toISOString(),
        to: to.toISOString(),
        beginnings: undefined,
      },
    };

    if (beginnings && beginnings !== null) body.body.beginnings = beginnings;

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (!suppressErrors) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (!suppressErrors) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public rawAll(
    from: Date,
    to: Date,
    onSuccess?: (raws: any) => void,
    onFailure?: () => void,
    suppressErrors: Boolean = false
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/raw/all",
      body: {
        token: this.iotToken,
        from: from.toISOString(),
        to: to.toISOString(),
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          if (!suppressErrors) this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        if (!suppressErrors) this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public deviceGetBySnr(
    snr: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/device/get",
      body: {
        token: this.iotToken,
        snr: snr,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public accountInfo(onSuccess?: (res?: any) => void, onFailure?: () => void) {
    let endpoint = this.apiRootNew + "/account/get";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          //Get the entity information
          this.entityAccid = r.accid;
          this.entityName = r.name;
          this.entityDescription = r.description;
          this.entityLogoBase64 = r.logo;
          this.entityAddress = r.address;
          this.entityEmail = r.email;
          this.entityPhone = r.phone;
          this.entityWeb = r.web;

          this.handleSuccess(response);
          if (onSuccess) onSuccess(r);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgUnitAdd(
    name: string,
    description: string,
    parentOrgId: string,
    scope: string,
    policy: string,
    classid: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/orgunits/add";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      name: name,
      description: description,
    };

    //Optional values
    if (parentOrgId) body["parentid"] = parentOrgId;
    if (scope) body["scope"] = scope;
    if (policy) body["policy"] = policy;
    if (classid) body["classid"] = classid;

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgUnitDelete(
    orgid: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/orgunits/delete";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      orgid: orgid,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgUnitEdit(
    orgid: string,
    name: string,
    description: string,
    parentOrgId?: string,
    scope?: string,
    policy?: string,
    classid?: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/orgunits/edit";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      orgid: orgid,
      name: name,
      description: description,
      parentid: parentOrgId ? parentOrgId : undefined,
      scope: scope ? scope : undefined,
      policy: policy ? policy : undefined,
      classid: classid ? classid : undefined,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgunitList(onSuccess?: (r: any) => void, onFailure?: () => void) {
    let endpoint = this.apiRootNew + "/orgunits/page";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      seq: 0,
      from: 0,
      length: 1000,
      search: "",
      order: "name",
      direction: "ASC",
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {

          //Filter if owner
          if (this.userAccess.role == "owner") {
            //Flter response
            console.log(1)
            let myOrgs = this.orgUnits.map((it) => {
              return it.classid
            });
            
            if (myOrgs && myOrgs.length > 0) {
              
              let data = r.data.filter((item) => {
                
                let classId = item.classid;
                // if()

                let condition = myOrgs.includes(classId)? true:false;
                
                return condition;

              })
              r.data = data;

            }


          }


          this.handleSuccess(response);
          if (onSuccess) onSuccess(r);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgUnitRelate(
    personid: string,
    orgid: string,
    remove: boolean,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/orgunits/relate";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      orgid: orgid,
      remove: remove,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public orgUnitRelateAnon(
    personid: string,
    orgid: string,
    remove: boolean,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/orgunits/relates/anonymous";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      personid: personid,
      orgid: orgid,
      remove: remove,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public classAdd(
    classObj: any,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    //Add the token
    classObj.token = this.iotToken;

    let body = {
      token: this.token,
      endpoint: "/class/add",
      body: classObj,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public classGet(
    classId: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/class/get",
      body: {
        token: this.iotToken,
        classId: classId,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public classList(
    classes: any,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/class/list",
      body: {
        token: this.iotToken,
        classes: classes,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public classRemove(
    classId: string,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      endpoint: "/class/remove",
      body: {
        token: this.iotToken,
        classId: classId,
      },
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public ruleAdd(
    ruleObj: any,
    onSuccess?: (result: any) => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/iot/proxy";

    let options = {
      headers: this.httpHeaders,
    };

    //Add the token
    ruleObj.token = this.iotToken;

    let body = {
      token: this.token,
      endpoint: "/rule/add",
      body: ruleObj,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          this.handleSuccess(response);
          if (onSuccess) onSuccess(r.data);
        } else {
          this.handleBadStatus(response);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  public changeAccount(
    accid: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    let endpoint = this.apiRootNew + "/account/change";

    let options = {
      headers: this.httpHeaders,
    };

    let body = {
      token: this.token,
      accid: accid,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.status) {
          //These parameters may change
          this.userAccess = r.access;
          this.iotActive = r.iotActive;
          this.iotAccess = r.iotAccess;

          //Reset the roles
          this.resetRoles();
          this.roles = this.roles.slice(
            this.roles.indexOf(this.userAccess.role) + 1
          );

          this.handleSuccess(response);
          if (onSuccess) onSuccess();
        } else {
          if (r.message && r.message == "Not found")
            r.message = "Account does not exist.";
          this.handleBadStatus(r);
          if (onFailure) onFailure();
        }
      },
      (error) => {
        this.handleApiErrors(error);
        if (onFailure) onFailure();
      }
    );
  }

  //#endregion

  //#region : Helpers
  getToolButtonHtml(
    className: string,
    faIcon: string,
    margin: number,
    hint: string,
    disabled: boolean = false
  ): string {
    var tool = `<a class="${className} ${
      disabled ? "saf-disabled" : ""
    }" title="${hint}" style="cursor:pointer; margin-right:${margin}px"><i class="fal ${faIcon} fa-fw"></i></a>`;

    return tool;
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateFormatEmail(email) {
    let testResult = "";
    if (email.length > 0) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      testResult = re.test(String(email).toLowerCase()) ? "" : "error-border";
    }

    return testResult;
  }

  matchingText(text1: string, text2: string) {
    // console.log(text1 + ":" + text2)
    let e = "";
    if (text1.length > 0 && text2.length > 0) {
      e = text1 !== text2 ? "error-border" : "";
    }
    return e;
  }

  matchingAndValidLength(text1: string, text2: string, minLength: number) {
    let e =
      text1.length < minLength || text2.length < minLength || text1 !== text2
        ? "error-border"
        : "";

    return e;
  }

  checkPwd(pwd: string) {
    //PASSWORD RULES:
    //The password length must be greater than or equal to 8
    //The password must contain one or more uppercase characters
    //The password must contain one or more lowercase characters
    //The password must contain one or more numeric values
    //The password must contain one or more special characters
    let regexPasswordValid =
      "(?=^.{8,}$)(?=.*\\d)(?=.*[!@#$%^&*]+)(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$";

    if (pwd.match(regexPasswordValid) || pwd.length == 0) {
      return "";
    } else {
      return "error-border";
    }
  }

  validatePwd(pwd: string) {
    let regexPasswordValid =
      "(?=^.{8,}$)(?=.*\\d)(?=.*[!@#$%^&*]+)(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$";

    if (pwd.match(regexPasswordValid) || pwd.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  public arrayFindWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  private handleBadStatus(response: any) {
    console.log(response);
    let r: any = response;

    this.showWarningAlert("Unsuccessful Request", r.message + ".");
  }

  showSuccessAlert(title: string, message: string) {
    this.swalWithBootstrapButtons.fire({
      title: title,
      html: message,
      showConfirmButton: true,
    });
  }

  showWarningAlert(title: string, message: string, onOk?: () => void) {
    this.swalWithBootstrapButtons
      .fire({
        title: title,
        html: message,
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "OK",
      })
      .then((result) => {
        if (onOk) onOk();
      });
  }

  showConfirmAlert(
    title: string,
    message: string,
    confirmBtnText: string,
    cancelBtnText: string,
    onOk?: () => void,
    onCancel?: () => void
  ) {
    this.swalWithBootstrapButtons
      .fire({
        title: title,
        html: message,
        icon: "question",
        confirmButtonText: confirmBtnText,
        cancelButtonText: cancelBtnText,
        showCancelButton: true,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          if (onOk) onOk();
        } else {
          if (onCancel) onCancel();
        }
      });
  }

  showSuccessConfirm(
    title: string,
    message: string,
    confirmBtnText: string,
    onOk?: () => void,
    onCancel?: () => void
  ) {
    this.swalWithBootstrapButtons
      .fire({
        title: title,
        html: message,
        icon: "success",
        showCancelButton: false,
        confirmButtonText: confirmBtnText,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          if (onOk) onOk();
        } else {
          if (onCancel) onCancel();
        }
      });
  }

  showSuccessOption(
    title: string,
    message: string,
    confirmBtnText: string,
    cancelBtnText: string,
    onOk?: () => void,
    onCancel?: () => void
  ) {
    this.swalWithBootstrapButtons
      .fire({
        title: title,
        html: message,
        icon: "success",
        confirmButtonText: confirmBtnText,
        cancelButtonText: cancelBtnText,
        showCancelButton: true,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          if (onOk) onOk();
        } else {
          if (onCancel) onCancel();
        }
      });
  }

  private handleApiErrors(error: any) {
    console.log(error);

    if (error.status == 422) {
      if (error.error && error.error.errors && error.error.errors.length > 0) {
        let err = error.error.errors[0];
        this.showWarningAlert(
          err.msg,
          `The following parameter is invalid: <b>${err.param}</b>`
        );

        return;
      }
    }

    this.showWarningAlert(
      "Invalid Request",
      "Communication error. Please check your connection."
    );
  }

  public handleSuccess(response: any) {
    this.resetSession();
  }

  public signout(showTimeoutMsg: boolean = true) {
    //Kill server token
    this.peopleEndSession(() => {
      //Clear local data
      this.clearSessionData();
    });

    this.signingOut = true;
    this.loggedOut = true;

    if (showTimeoutMsg) {
      this.showWarningAlert(
        "Session Timeout",
        "The session has ended due to inactivity.",
        () => {
          //Reload window
          location.reload();
        }
      );
    } else {
      //Reload window
      location.reload();
    }
  }

  public stopSession() {
    this.token = null;

    //Stop current running timers
    if (this.timerSession !== null) {
      clearTimeout(this.timerSession);
      this.timerSession = null;
    }
  }

  public resetSession(timeout: number = 21000000) {
    // 3500000 == 60min
    // 900000 == 15min
    // 84000000 == 24hrs
    // 21000000 == 6hrs

    //Stop current running timers
    if (this.timerSession !== null) clearTimeout(this.timerSession);

    //Start the timer
    this.timerSession = setTimeout(() => {
      this.handleSessionTimeout();
    }, timeout);
  }

  private handleSessionTimeout() {
    this.signout(true);
  }

  resetRoles() {
    this.roles = this.defRoles;
  }

  getUrl(url) {
    url = url.replace(/\$ctoken/g, `ctoken=${this.token}`);
    url = url.replace(/\$itoken/g, `itoken=${this.iotToken}`);
    url = url.replace(/\$personid/g, `personid=${this.personid}`);
    url = url.replace(/\$accid/g, `accid=${this.entityAccid}`);
    url = url.replace(/\$username/g, `username=${this.username}`);
    url = url.replace(/\$nickname/g, `nickname=${this.nickname}`);
    url = url.replace(/\$email/g, `email=${this.email}`);
    url = url.replace(/\$flavour/g, `flavour=${this.buildSettings.appFlavour}`);
    url = url.replace(/\$token/g, `email=${this.token}`);
    url = url.replace(/\$role/g, `role=${this.userAccess.role}`);
    url = url.replace(
      /\$ftp/g,
      `flavourtype=${this.buildSettings.flavourType}`
    );
    url = url.replace(/\$entity/g, `entity=${this.entityName}`);

    url = this.sanitizer.sanitize(
      SecurityContext.URL,
      this.sanitizer.bypassSecurityTrustResourceUrl(url)
    );

    return url;
  }

  //#endregion

  //#region Permissions

  public permitSingle(
    accessGroup: AccessGroup,
    accessLevel: AccessLevel
  ): boolean {
    if (this.userAccess) {
      if (this.userAccess[accessGroup] & accessLevel) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public permitHideSingle(
    accessGroup: AccessGroup,
    accessLevel: AccessLevel,
    id: string
  ) {
    if (this.permitSingle(accessGroup, accessLevel)) {
      if (id) $(id).show();
    } else {
      if (id) $(id).hide();
    }
  }

  public permitDisableSingle(
    accessGroup: AccessGroup,
    accessLevel: AccessLevel,
    id?: string
  ) {
    if (this.permitSingle(accessGroup, accessLevel)) {
      if (id) {
        // $(id).css("cursor", "not-allowed");
        $(id).prop("disabled", false);
        $(id + " :input").prop("disabled", false);
      }
    } else {
      $(id).prop("disabled", true);
      $(id + " :input").prop("disabled", true);
    }
  }

  public permitHideAll(accessGroup: AccessGroup) {
    this.permitHideSingle(accessGroup, AccessLevel.VIEW_L1, ".access-view-l1");
    this.permitHideSingle(accessGroup, AccessLevel.VIEW_L2, ".access-view-l2");
    this.permitHideSingle(accessGroup, AccessLevel.VIEW_L3, ".access-view-l3");
    this.permitHideSingle(accessGroup, AccessLevel.VIEW_L4, ".access-view-l4");
    this.permitHideSingle(accessGroup, AccessLevel.VIEW_L5, ".access-view-l5");
  }

  public permitDisableAll(accessGroup: AccessGroup) {
    this.permitDisableSingle(accessGroup, AccessLevel.CREATE, ".access-create");
    this.permitDisableSingle(accessGroup, AccessLevel.EDIT, ".access-edit");
    this.permitDisableSingle(accessGroup, AccessLevel.DELETE, ".access-delete");
    this.permitDisableSingle(
      accessGroup,
      AccessLevel.EXECUTE,
      ".access-execute"
    );
  }

  public drawPermissionBadge(selector: any, text: string, hasAccess: boolean) {
    let all = $("[class*=" + selector + "]");

    all.each((index, element) => {
      var el = $(element);
      var badge;

      if (hasAccess) {
        badge =
          " <span class='label label-success label-access'>" +
          text +
          "</span> ";
      } else {
        badge =
          " <span class='label label-danger label-access'>" + text + "</span> ";
      }

      if (el.is(":button")) {
        el.append(badge);
      } else if (el.is("label")) {
        el.append(badge);
      } else if (el.is("select")) {
        el.before(badge);
      } else if (el.is(":checkbox")) {
        el.after(badge);
      } else if (el.is(":input")) {
        el.before(badge);
      } else if (el.is("div")) {
        $($(el.children()[0]).children()[0]).after(badge);
      }
    });
  }

  public showPermissions(accessGroup: AccessGroup) {
    $(".label-access").remove();

    this.drawPermissionBadge(
      "access-edit",
      "E",
      this.permitSingle(accessGroup, AccessLevel.EDIT)
    );
    this.drawPermissionBadge(
      "access-create",
      "C",
      this.permitSingle(accessGroup, AccessLevel.CREATE)
    );
    this.drawPermissionBadge(
      "access-execute",
      "X",
      this.permitSingle(accessGroup, AccessLevel.EXECUTE)
    );
    this.drawPermissionBadge(
      "access-view-l1",
      "V1",
      this.permitSingle(accessGroup, AccessLevel.VIEW_L1)
    );
    this.drawPermissionBadge(
      "access-view-l2",
      "V2",
      this.permitSingle(accessGroup, AccessLevel.VIEW_L2)
    );
    this.drawPermissionBadge(
      "access-view-l3",
      "V3",
      this.permitSingle(accessGroup, AccessLevel.VIEW_L3)
    );
    this.drawPermissionBadge(
      "access-view-l4",
      "V4",
      this.permitSingle(accessGroup, AccessLevel.VIEW_L4)
    );
    this.drawPermissionBadge(
      "access-view-l5",
      "V5",
      this.permitSingle(accessGroup, AccessLevel.VIEW_L5)
    );
  }

  public hidePermissions() {
    $(".label-access").remove();
  }

  public hasAgentAccess() {
    return this.permitSingle(AccessGroup.account, AccessLevel.CREATE);
  }

  public hasOwnerAccess() {
    return this.permitSingle(AccessGroup.dashboard, AccessLevel.CREATE);
  }

  public isOwner() {
    return this.userAccess.role == "owner" ? true : false;
  }

  public isAgent() {
    return this.userAccess.role == "agent" ||
      this.userAccess.role == "root" ||
      this.userAccess.role == "super"
      ? true
      : false;
  }

  public isManager() {
    return this.userAccess.role == "manager" ? true : false;
  }

  public isUser() {
    return this.userAccess.role == "user" ? true : false;
  }

  //#endregion

  //#region : Analytics

  public getTotals(snr?: string): any {
    //Format the header
    let result: any[] = [
      [
        "Day",
        "Scans",
        {
          role: "style",
        },
        "Alarms",
        {
          role: "style",
        },
        "Scans",
        "Alarms",
      ],
    ];

    //Push the data
    for (var dayEntry of this.dataMap.entries()) {
      let scans = 0;
      let alarms = 0;
      let day = dayEntry[0];
      let deviceMap: Map<string, ScanHolder> = dayEntry[1];

      for (var dev of deviceMap.entries()) {
        let devSnr = dev[0];

        if (!snr || devSnr == snr) {
          let scanDay: ScanHolder = dev[1];

          scans += scanDay.scanCount;
          alarms += scanDay.alarmCount;
        }
      }

      result.push([
        day,
        scans,
        "opacity: 0.5",
        alarms,
        "opacity: 0.5",
        scans,
        alarms,
      ]);
    }

    return result;
  }

  //#endregion
}
